import { createSelector } from '@reduxjs/toolkit';

import installationSelector from './installation';

const pageReadySelector = createSelector(
  installationSelector,
  installation => installation.page.ready,
);

export default pageReadySelector;
